(function () {
  function getForm() {
  const mainPicker = document.querySelector(
    '[id^="ProductPage-"] variant-selects'
  );

  const select = mainPicker?.querySelector(
    'select[name^="options["]'
  );

  // The dropdown's form attribute identifies the correct product form.
  if (select?.form) return select.form;

  return document.querySelector(
    '[id^="ProductPage-"] form[action*="/cart/add"]'
  ) || document.querySelector('form[action*="/cart/add"]');
}

function getSectionRoot(el) {
  const picker = el?.closest?.('variant-selects');
  if (picker) return picker;

  // Find the picker associated with this specific form.
  if (el instanceof HTMLFormElement) {
    const linkedSelect = Array.from(
      document.querySelectorAll(
        'variant-selects select[name^="options["]'
      )
    ).find(select => select.form === el);

    if (linkedSelect) {
      return linkedSelect.closest('variant-selects');
    }
  }

  return el?.closest?.('[id^="ProductPage-"]') || document;
}
  function getSelects(sectionRoot) {
  let selects = Array.from(
    sectionRoot.querySelectorAll('variant-selects select[name^="options["]')
  );

  if (!selects.length) {
    selects = Array.from(
      sectionRoot.querySelectorAll('select[name^="options["]')
    );
  }

  return selects;
}

  function getIdInput(form) {
    return form?.querySelector('input[name="id"]');
  }

  function getVariants(sectionRoot) {
  // Try inside the section first
  let script = sectionRoot.querySelector('script[type="application/json"][data-id="product-variants"]');

  // Fallback: search the whole document (prevents "variants=[]" on submit)
  if (!script) script = document.querySelector('script[type="application/json"][data-id="product-variants"]');

  if (!script) return [];
  try {
    return JSON.parse(script.textContent) || [];
  } catch (e) {
    return [];
  }
}

  function selectedOptions(selects) {
  return selects.map(s => {
    const v = (s.value || "").trim();
    if (!v) return "";

    // decode HTML entities just in case (e.g. &amp;)
    const txt = document.createElement('textarea');
    txt.innerHTML = v;
    return txt.value.trim();
  });
}

  function allChosen(opts) {
    return opts.length > 0 && opts.every(v => v !== "");
  }

  function findVariant(variants, opts) {
    return variants.find(v => {
      for (let i = 0; i < opts.length; i++) {
        if ((v["option" + (i + 1)] || "") !== opts[i]) return false;
      }
      return true;
    }) || null;
  }

  function showBubble(selects) {
  const first = selects.find(s => !s.value);
  if (!first) return true;

  // Remove old bubble + invalid state
  document.querySelectorAll('.lc-validate-bubble').forEach(el => el.remove());
  document.querySelectorAll('.lc-validate-invalid').forEach(el => {
    el.classList.remove('lc-validate-invalid');
  });

  // Create bubble
  const bubble = document.createElement('div');
  bubble.className = 'lc-validate-bubble';
  bubble.setAttribute('role', 'alert');
  bubble.innerHTML = `
    <span class="lc-validate-bubble__icon" aria-hidden="true">!</span>
    <span class="lc-validate-bubble__text">Please select an item in the list.</span>
  `;

  // wrappers
  const variantsWrap =
    first.closest('variant-selects') ||
    first.closest('.product-variants') ||
    first.closest('.product-block') ||
    first.closest('form[action*="/cart/add"]');

  const fieldWrap =
    first.closest('.product-form-input-dropdown') ||
    first.closest('.product-form-input') ||
    first.closest('.product-form__input') ||
    first.parentElement;

  const useGroupWrap = selects.length > 1 && variantsWrap;
  const wrap = useGroupWrap ? variantsWrap : fieldWrap;

  if (!wrap) return false;

  if (window.getComputedStyle(wrap).position === 'static') {
    wrap.style.position = 'relative';
  }

  wrap.appendChild(bubble);

  if (useGroupWrap) {
    // Put the bubble BELOW the variant option names area
    const firstField =
      selects[0].closest('.product-form-input-dropdown') ||
      selects[0].closest('.product-form-input') ||
      selects[0].closest('.product-form__input') ||
      selects[0].parentElement;

    const firstFieldTop = firstField ? firstField.offsetTop : first.offsetTop;

    bubble.style.position = 'absolute';
    bubble.style.top = (firstFieldTop - 8) + 'px';
    bubble.style.left = '0px';
    bubble.style.right = 'auto';
    bubble.style.whiteSpace = 'normal';
    bubble.style.maxWidth = '320px';
    bubble.style.zIndex = '9999';
  } else {
    // Single dropdown: place under that dropdown
    const top = first.offsetTop + first.offsetHeight + 8;
    let left = first.offsetLeft;

    bubble.style.position = 'absolute';
    bubble.style.top = top + 'px';
    bubble.style.left = left + 'px';
    bubble.style.zIndex = '9999';

    requestAnimationFrame(() => {
      const bubbleWidth = bubble.offsetWidth;
      const wrapWidth = wrap.clientWidth;

      if (bubbleWidth > wrapWidth - 12) {
        bubble.style.whiteSpace = 'normal';
        bubble.style.maxWidth = Math.max(180, wrapWidth - 12) + 'px';
        bubble.style.left = '0px';
      } else if (left + bubbleWidth > wrapWidth) {
        bubble.style.left = Math.max(0, wrapWidth - bubbleWidth) + 'px';
      }
    });
  }

  first.classList.add('lc-validate-invalid');

  const remove = () => {
    first.classList.remove('lc-validate-invalid');
    if (bubble && bubble.parentNode) bubble.remove();

    first.removeEventListener('change', remove);
    first.removeEventListener('input', remove);
    window.removeEventListener('scroll', remove, true);
    window.removeEventListener('resize', remove);
  };

  first.addEventListener('change', remove);
  first.addEventListener('input', remove);
  window.addEventListener('scroll', remove, true);
  window.addEventListener('resize', remove);

  first.focus();
  return false;
}

  function syncId(form, sectionRoot) {
    const idInput = getIdInput(form);
    if (!idInput) return;

    const selects = getSelects(sectionRoot);
    const opts = selectedOptions(selects);

    if (!allChosen(opts)) {
      idInput.value = ""; // force blocked
      return;
    }

    const variants = getVariants(sectionRoot);
    const match = findVariant(variants, opts);
    idInput.value = match ? String(match.id) : "";
  }

  // Select the URL variant; otherwise show the placeholders.
document.addEventListener('DOMContentLoaded', () => {
  const form = getForm();
  if (!form) return;

  form.setAttribute('novalidate', 'novalidate');
  form.noValidate = true;

  const sectionRoot = getSectionRoot(form);
  const selects = getSelects(sectionRoot);
  const idInput = getIdInput(form);

  if (!selects.length || !idInput) return;

  const variantId = new URLSearchParams(window.location.search)
    .get('variant');

  const variants = getVariants(sectionRoot);
  const urlVariant = variants.find(
    variant => String(variant.id) === variantId
  );

  // Confirm all the variant's options exist in the picker.
  const canSelectVariant = urlVariant && selects.every((select, index) => {
    const position = Number(select.dataset.optionPosition || index + 1);
    const value = urlVariant.options?.[position - 1]
      ?? urlVariant['option' + position];

    return Array.from(select.options).some(
      option => option.value === value
    );
  });

  selects.forEach((select, index) => {
    select.removeAttribute('required');
    select.required = false;
    select.setCustomValidity('');

    if (canSelectVariant) {
      const position = Number(select.dataset.optionPosition || index + 1);

      select.value = urlVariant.options?.[position - 1]
        ?? urlVariant['option' + position];
    } else {
      select.value = '';
    }
  });

  idInput.value = canSelectVariant ? String(urlVariant.id) : '';

  // Update the theme's price, image, availability and cart variant.
  if (canSelectVariant) {
    selects[selects.length - 1].dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
});

// Suppress native browser validation bubbles
document.addEventListener('invalid', function (e) {
  e.preventDefault();
}, true);

  // Update ID on selection changes
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!(t instanceof HTMLSelectElement)) return;
    if (!t.name?.startsWith('options[')) return;

    const form = t.closest('form[action*="/cart/add"]') || getForm();
    if (!form) return;

    const sectionRoot = getSectionRoot(t);

  t.removeAttribute('required');
t.required = false;
t.setCustomValidity('');

    // Let theme update availability then sync id
    setTimeout(() => syncId(form, sectionRoot), 0);
    setTimeout(() => syncId(form, sectionRoot), 50);
  }, true);

  // Block Add to Cart
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action?.includes('/cart/add')) return;

    const sectionRoot = getSectionRoot(form);
    const selects = getSelects(sectionRoot);
    const idInput = getIdInput(form);

    if (!selects.length || !idInput) return;

    syncId(form, sectionRoot);

    const opts = selectedOptions(selects);
    if (!allChosen(opts) || !idInput.value) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  form.setAttribute('novalidate', 'novalidate');
  form.noValidate = true;

  selects.forEach(sel => {
    sel.removeAttribute('required');
    sel.required = false;
    sel.setCustomValidity('');
  });

  idInput.value = "";
  showBubble(selects);
  return false;
}
  }, true);
})();
